import ApplicationController from "../application_component_controller";

import { duplicate } from "hb/insights/utils";
import { useOutlets } from "hb/insights/use_outlets";
import { useListen } from "hb/insights/use_listen";
import { loadConfig } from "hb/insights/trigger_configs";
import { debounce } from "hb/lib/utils";
import URL from "hb/lib/url";

export default class extends ApplicationController {
  static targets = [
    "updatableInput",
    "triggerInput",
    "updateButton",
    "validateForm",
    "form",
  ];
  static values = {
    observer: Object,
  };

  connect() {
    useListen(this);

    this.observer = this.observerValue;
    this.baseObserver = duplicate(this.observer);

    this.inputUpdateHandler = this.inputUpdate.bind(this);
    this.triggerUpdateHandler = this.triggerUpdate.bind(this);
    this.updatableInputTargets.forEach((input) => {
      input.addEventListener("change", this.inputUpdateHandler);
    });

    this.triggerInputTargets.forEach((input) => {
      if (input.type === "text") {
        input.addEventListener(
          "keydown",
          debounce((evt) => this.triggerUpdateHandler(evt), 200),
        );
      } else {
        input.addEventListener("change", this.triggerUpdateHandler);
      }
    });

    this.listenWindow("queryStreamChanged", this.onStreamSelected);

    const configClass = loadConfig(this.observer?.trigger_config?.type);
    if (configClass) {
      this.triggerConfig = new configClass(this.observer);
    }

    useOutlets(this, { components: ["query", "preview"], scope: this.element });
  }

  disconnect() {
    this.updatableInputTargets.forEach((input) => {
      input.removeEventListener("change", this.inputUpdateHandler);
    });

    this.triggerInputTargets.forEach((input) => {
      if (input.type === "checkbox") {
        input.removeEventListener("change", this.triggerUpdateHandler);
      } else {
        input.removeEventListener("input", this.triggerUpdateHandler);
      }
    });
  }

  onStreamSelected() {
    this.shouldValidate();
  }

  inputUpdate() {
    this.shouldValidate();
  }

  triggerUpdate(evt) {
    this.outletComponent("preview")?.updateTriggerConfig(
      evt.target.name,
      evt.target.value,
    );
  }

  shouldValidate() {
    this.updateButtonTarget.textContent = "Update Preview";
    this.updateButtonTarget.classList.remove("btn-primary");
    this.updateButtonTarget.classList.add("btn-info");
    this.validateFormTarget.value = "true";
    delete this.formTarget.dataset.turboFrame;
  }

  outletsConnected() {
    this.outletComponent("query").listen("queryChange", () => {
      this.shouldValidate();
    });

    URL.replaceParam("query", null);
    URL.replaceParam("stream_ids", null);
  }
}
